import { render } from "./PressReleases.vue?vue&type=template&id=ec908906"
import script from "./PressReleases.vue?vue&type=script&lang=js"
export * from "./PressReleases.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__